<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .menu-local
        display: flex
        position: fixed
        bottom: 12px
        left: 24px
        flex-direction: column-reverse
        align-items: stretch
        justify-content: flex-start
        z-index: 2
        padding: 4px

        +media("<=1024px")
            font-size: 14px
            flex-direction: row
            align-items: center

        +media("<=768px")
            font-size: 12px

        &.visible
            background: rgba(208,42,76,.2)

            +media("<=1024px")
                background: rgba(208,42,76,.5)

            ul
                visibility: visible


        ul
            display: flex
            flex-direction: column
            align-items: stretch
            justify-content: flex-start
            list-style-type: none
            margin: 0
            padding: 0
            visibility: hidden

            +media("<=1024px")
                flex-direction: row
                bottom: 0

            li
                background: #fff
                color: rgb(208,42,76)
                padding: 4px 12px
                border: 1px solid rgb(208,42,76)
                border-radius: 50px
                margin: 3px 0
                text-align: center

                +media("<=1024px")
                    padding: 4px 6px
                    margin: 3px

        &--btn
            color: #fff
            background: rgba(208,42,76,.9)
            padding: 4px 12px
            border: 1px solid rgb(208,42,76)
            border-radius: 50px
            margin: 3px 0
            text-align: center
            z-index: 2

            &:hover
                cursor: pointer

            +media("<=1024px")
                padding: 4px 6px
                margin: 3px

</style>

<script>
    export default {
        mounted: function() {
            const ml = document.querySelector('.menu-local');
            const btn = ml.querySelector('.menu-local--btn');

            btn.addEventListener('click', function (){
                ml.classList.toggle('visible');

                if(ml.classList.contains('visible')) {
                    btn.ariaExpanded = 'true';
                } else {
                    btn.ariaExpanded = 'false';
                }
            });
        }
    }
</script>
